<div class="version-related-group single-version">
    <div class="group-item" *ngIf="version != null else loadingSingleVersionFiles">
        <header>
            <strong class="group-counter">1</strong>
            <core-labels-list [labels]="groupLabels"></core-labels-list>
        </header>
        <ul class="version-related-item">
            <li>
              <core-version-files-list-checkbox
                [version]="version"
                [feedbacks]="feedbacks"
                [selected]="selected"
                (selectedChange)="onChange($event);"
                [disabled]="disabled"
            ></core-version-files-list-checkbox>
            </li>
        </ul>
    </div>
    <ng-template #loadingSingleVersionFiles>
    <div class="loader">
        <div class="dimmed">
            <div class="dimmed_box"></div>
        </div>
    </div>
    </ng-template>

</div>